import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ProgramCard = ({ 
  icon: Icon, 
  title, 
  description, 
  href = '/programs',
  className = '',
  span = 'col-span-12 md:col-span-6 lg:col-span-4'
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`${span} ${className}`}
    >
      <Link to={href} data-testid={`program-card-${title.toLowerCase().replace(/\s+/g, '-')}`}>
        <div className="card-spotlight h-full bg-card border border-border rounded-2xl p-6 hover:border-primary/30 transition-all duration-300 group">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
              <Icon className="h-6 w-6" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-foreground font-['Outfit'] mb-2 group-hover:text-primary transition-colors">
                {title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed">
                {description}
              </p>
            </div>
            <ArrowRight className="h-5 w-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProgramCard;
